import { pbrExt } from './fragments/clearcoat-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrClearCoat(mat, clearCoat) {
  mat._clearCoat = clearCoat;
  _registerPbrExt(pbrExt);
}

export { setPbrClearCoat };
//# sourceMappingURL=set-clearcoat.js.map
